// Small builders that keep the lesson files readable.
export const p = (text) => ({ type: 'p', text });
export const h = (text) => ({ type: 'h', text });
export const ul = (items) => ({ type: 'ul', items });
export const ol = (items) => ({ type: 'ol', items });
export const code = (lang, text, title) => ({ type: 'code', lang, text: text.replace(/^\n/, '').replace(/\s+$/, ''), title });
export const tip = (title, text) => ({ type: 'callout', kind: 'tip', title, text });
export const info = (title, text) => ({ type: 'callout', kind: 'info', title, text });
export const warn = (title, text) => ({ type: 'callout', kind: 'warn', title, text });
export const table = (head, rows) => ({ type: 'table', head, rows });
export const cards = (items) => ({ type: 'cards', items });
// actors: ['Alice', 'Proxy', 'Bob']; msgs: [from, to, label, style?] where style is 'req' | 'resp' | 'media'
export const ladder = (title, actors, msgs) => ({ type: 'ladder', title, actors, msgs });
export const steps = (items) => ({ type: 'steps', items });
